import { DefaultFocusStatusModel } from "../DefaultFocusStatusModel";

// Helper function to check if an element is focusable (not tabIndex="-1")
export function isFocusable(element: DefaultFocusStatusModel): boolean {
    if (!element.elementRef?.current) return false;
    const node = element.elementRef.current;
    const tabIndex = node.getAttribute("tabindex");
    const ariaDisabled = node.getAttribute("aria-disabled");
    const ariaHidden = node.getAttribute("aria-hidden");
    // Native disabled form controls (e.g. an open-end textarea for an unselected choice)
    // can't receive focus even though they carry no tabindex/aria-disabled attribute.
    const isNativelyDisabled = (node as HTMLInputElement | HTMLTextAreaElement).disabled === true;

    // Element is focusable if tabIndex is not -1 and not disabled/hidden
    return (
        tabIndex !== "-1" &&
        ariaDisabled !== "true" &&
        ariaHidden !== "true" &&
        !isNativelyDisabled
    );
}
